var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcImg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0M13.159 11.575a5 5 0 0 1 6.949.118L22 13.586s-.707 2.277-.707 2.121l-2.6-2.6a3 3 0 0 0-4.169-.07L5.5 21.5c.377.404-.404.377 0 0l-2-1z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M6 2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4z",
  clipRule: "evenodd"
})));
export default SvgIcImg;